import { render, staticRenderFns } from "./ModalReject.vue?vue&type=template&id=0b9d0538&"
import script from "./ModalReject.vue?vue&type=script&lang=js&"
export * from "./ModalReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports